module.exports = __webpack_public_path__ + "img/your-account.0a11d48f.svg";